import { BaseType } from '../../base/base-type';
import { PaymentMethodTypeEnum } from '../../enum/shared/payment-method-type-enum';

export class PaymentMethodType extends BaseType {
  public declare id: PaymentMethodTypeEnum;
}
